<template>
    <console-content max-width="1280">
        <v-row class="mt-0 mt-md-4 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">상품목록</v-col>
            <v-spacer/>
            <v-col cols="auto">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-2 mx-1">
                <v-card-title class="tit tit--xs font-weight-bold">검색필터</v-card-title>
                <v-card-text class="pb-0">
                    <category-select v-model="filter._category" :categories="categories" @input="page = 1; search(true)" />
                    <v-row>
                        <v-col cols="12" sm="3">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-refresh</v-icon>초기화
                    </v-btn>
                    <v-btn color="primary" rounded text @click="page = 1; search(true)">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-layout class="mt-4 px-1" align-end>
            <v-flex>검색수 : {{ summary.totalCount.format() }}</v-flex>
            <v-spacer />
            <v-flex cols="auto" class="flex-grow-0">
                <v-btn color="white" class="green--text" elevation="1" @click="excel">
                    <v-icon left size="20">mdi-microsoft-excel</v-icon>엑셀다운로드
                </v-btn>
            </v-flex>
        </v-layout>

        <v-data-table v-model="selected" :items="products" item-key="_id" :headers="productsHeaders" hide-default-footer disable-sort disable-pagination show-select class="mt-2 mx-1 elevation-1">
            <template #[`item.thumb`]="{item}">
                <v-img :src="`https://daehanbooks.co.kr`+ item.thumb" max-width="96" height="96" contain class="ma-auto"/>
            </template>
            <template #[`item.createdAt`]="{item}">
                <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
            </template>
            <template #[`item.actions`]="{item}">
                <span>
                    <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
                </span>
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

        <excel-dialog ref="excelDialog" />

    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import ExcelDialog from "@/components/console/shop/products/excel-dialog.vue";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import CategorySelect from "@/components/console/shop/categories/category-select.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        CategorySelect,
        ExcelDialog
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                type: "main",

                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,

                _category: null,
            },

            categories: [],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            selected: [],
            summary: { totalCount: 0 },
            products: [],
            productsHeaders: [
                { text: "진열순서", value: "no", align: "center", width: 100  },
                { text: "상품코드", value: "code", align: "center", width: 150 },
                { text: "썸네일", value: "thumb", align: "center", width: 150 },
                { text: "상품이름", value: "name", align: "center", /* width: 10 */ },
                { text: "재고", value: "stock", align: "center", width: 100  },
                { text: "등록일자", value: "createdAt", align: "center", width: 180 },
                // { text: "actions", value: "actions", align: "center", width: 100 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "상품이름", value: "name" },
                { text: "상품코드", value: "code" },
                { text: "출판사", value: "publisher" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            this.search(false);

            let { categories } = await api.console.shop.categories.gets({ params: { depth: 1 } });
            this.categories = categories;
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, products } = await api.console.shop.products.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.products = products;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        create(){
            this.$router.push(`/console/shop/products/create`);
        },
        edit(product){
            this.$router.push(`/console/shop/products/${product._id}`);
        },
        async remove(product){
            if(confirm("삭제하시겠습니까?")){
                await api.console.shop.products.delete(product);
                alert("삭제되었습니다");
                this.search(false);
            }
        },
        async updateNaverShopping(all = false){
            if(all){
                await api.plugins.naver.shopping.products();
                alert("전체 상품정보가 업데이트 되었습니다");
            }
            else {
                if(!this.selected.length) alert("업데이트 상품을 선택해주세요");
                else{
                    await api.plugins.naver.shopping.products({
                        params: {
                            _products: this.selected.map(product => product._id)
                        }
                    });
                    alert("요약 상품정보가 업데이트 되었습니다");
                }
            }
        },
        async excel(){
            this.$refs.excelDialog.open();
            this.$refs.excelDialog.$once("confirm", async (selected) => {
                let { products } = await api.console.shop.products.gets({ headers: { limit: 0 }, params: this.filter });

                let rows = [];
                products.forEach(product => {
                    let row = {};
                    for(let field of selected){
                        switch(field){
                            case "name": { row["상품이름"] = product[field]; break; }
                            case "code": { row["상품코드"] = product[field]; break; }
                            case "category": {
                                row["카테고리"] = product.categories?.reduce?.((categoryNames, category, index) => {
                                    let names = [];
                                    [...category._parents, category._id].reduce((categories, _id) => {
                                        let category = categories.find(category => category._id == _id);
                                        names.push(category?.name);
                                        return category?.children || [];
                                    },this.categories);
                                    return `${0 < index ? " , " : ''}${categoryNames + names.join('>')}`;
                                }, "");
                                break;
                            }
                            case "onDisplay": { row["상품진열"] = product[field] ? "진열" : "-"; break; }
                            case "soldout": { row["품절여부"] = product[field] ? "품절" : "-"; break; }
                            case "stock": { row["재고량"] = product[field]; break; }
                            case "costPrice": { row["소비자가(정가)"] = parseInt(product[field]).format(); break; }
                            case "salePrice": { row["판매가"] = parseInt(product[field]).format(); break; }
                            case "pointPercent": { row["포인트적립"] = `${product[field]}%`; break; }
                            case "optionalProducts": {
                                row["옵션"] = product?.optionalProducts?.reduce?.((optionalValues, optionalProduct, index) => {
                                    if(index == 0) optionalValues += `[${optionalProduct.optionalNames}]`;
                                    return optionalValues += `${0 < index ? " | " : ''}${optionalProduct.optionalValues.toString()}`;
                                }, "") || "-"; break;
                            }
                            case "images": { row["상품사진"] = product[field].join(","); break; }
                            case "writer": { row["작가"] = product[field]; break; }
                            case "publisher": { row["출판사"] = product[field]; break; }
                            case "isDeduction": { row["공제분류"] = product[field] ? "공제" : "미공제"; break; }
                            case "shippingCode": {
                                if(product[field] === "order") {
                                    row["배송정책"] = "기본정책"
                                }
                                if(product[field] === "free") {
                                    row["배송정책"] = "무료정책"
                                }
                                if(product[field] === "later") {
                                    row["배송정책"] = "착불정책"
                                }
                                if(product[field] === "self") {
                                    row["배송정책"] = "상품정책"
                                }
                                break;
                            }
                            case "publisher": { row["출판사"] = product[field]; break; }
                            default: { row[field] = product[field]; break;
                            }
                        }
                    }

                    rows.push(row);
                });

                let workbook = new XLSX.utils.book_new();
                let worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "상품목록");
                XLSX.writeFile(workbook, "상품목록.xlsx");
            });
        }
    }
}
</script>